// extracted by mini-css-extract-plugin
export default {"title":"RevenueOfEventTickets_title__q-Jmw","total":"RevenueOfEventTickets_total__PR4XT","table":"RevenueOfEventTickets_table__ubeIk"};